import React from 'react';
import PropTypes from 'prop-types';
import { ContributionButton, ContributionPicker } from './ContributionPickerStyles';
import {
  DOLLAR_CONTRIBUTION,
  PERCENTAGE_CONTRIBUTION,
} from '../../AccountsWorkflow/AccountsWorkflowConstants';

const ContributionPickerView = ({
  contributionType,
  onDollarClick,
  onPercentClick,
  disabled,
  style,
}) => (
  <ContributionPicker style={{ pointerEvents: disabled ? 'none' : 'auto', ...style }}>
    <ContributionButton
      type="button"
      active={contributionType === DOLLAR_CONTRIBUTION}
      onClick={onDollarClick}
      disabled={disabled}
    >
      $
    </ContributionButton>
    <ContributionButton
      type="button"
      active={contributionType === PERCENTAGE_CONTRIBUTION}
      onClick={onPercentClick}
      disabled={disabled}
    >
      %
    </ContributionButton>
  </ContributionPicker>
);

ContributionPickerView.defaultProps = {
  disabled: false,
  style: {},
};

ContributionPickerView.propTypes = {
  contributionType: PropTypes.oneOf([DOLLAR_CONTRIBUTION, PERCENTAGE_CONTRIBUTION]).isRequired,
  onDollarClick: PropTypes.func.isRequired,
  onPercentClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  style: PropTypes.shape({}),
};

export default ContributionPickerView;
